
module.exports = require('./bin/error');
